export const linkUrl = "https://dental.gdentalclinic.com.np/api"
export const imgUrl = "https://dental.gdentalclinic.com.np/"

